import { defineMessages } from 'react-intl';

/**
 * Message descriptors for ValidateAndUploadView file input and related labels.
 */
export const validateAndUploadViewMessages = defineMessages({
  selectFileLabel: {
    id: 'common.selectFileLabel',
    defaultMessage: 'Seleccionar archivo {extensions}',
  },
});
